// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const Account = __t.object("Account", {
  identity: __t.identity(),
  username: __t.string(),
  admin: __t.bool(),
  connection: __t.option(__t.connectionId()),
  instance: __t.u32(),
  character: __t.u64(),
  created: __t.timestamp(),
});
export type Account = __Infer<typeof Account>;

export const Bag = __t.object("Bag", {
  id: __t.u32(),
  instance: __t.u32(),
  x: __t.f32(),
  y: __t.f32(),
  owner: __t.u64(),
  ownerIdentity: __t.option(__t.identity()),
  get contents() {
    return __t.array(Stack);
  },
  ageTicks: __t.u32(),
});
export type Bag = __Infer<typeof Bag>;

export const Body = __t.object("Body", {
  entityId: __t.u16(),
  instance: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  facingFlags: __t.u8(),
  healthPct: __t.u8(),
  stamina: __t.i32(),
  staminaDelay: __t.u8(),
  ack: __t.u32(),
  epoch: __t.u8(),
  stun: __t.u8(),
});
export type Body = __Infer<typeof Body>;

export const Buff = __t.object("Buff", {
  id: __t.u64(),
  entityId: __t.u16(),
  instance: __t.u32(),
  kind: __t.u8(),
  startTick: __t.u32(),
  endTick: __t.u32(),
});
export type Buff = __Infer<typeof Buff>;

export const Character = __t.object("Character", {
  id: __t.u64(),
  owner: __t.identity(),
  nameKey: __t.string(),
  name: __t.string(),
  appearance: __t.u8(),
  map: __t.string(),
  x: __t.f32(),
  y: __t.f32(),
  facing: __t.u8(),
  health: __t.option(__t.f32()),
  mana: __t.option(__t.f32()),
  stamina: __t.option(__t.i32()),
  staminaDelay: __t.u8(),
  exhausted: __t.bool(),
  nextAttack: __t.u32(),
  nextConsumable: __t.u32(),
  level: __t.i32(),
  exp: __t.i32(),
  money: __t.i64(),
  statPoints: __t.array(__t.i32()),
  get main() {
    return __t.option(__t.array(Stack));
  },
  get belt() {
    return __t.array(Stack);
  },
  get armor() {
    return __t.array(Stack);
  },
  inventoryRevision: __t.u64(),
  get quests() {
    return __t.array(QuestRow);
  },
  get ignores() {
    return __t.array(IgnoreRow);
  },
  get friends() {
    return __t.array(FriendRow);
  },
  created: __t.timestamp(),
  lastSeen: __t.timestamp(),
  playTimeSeconds: __t.f64(),
  talents: __t.array(__t.u16()),
});
export type Character = __Infer<typeof Character>;

export const Clock = __t.object("Clock", {
  id: __t.u8(),
  tick: __t.u64(),
  dayPhase: __t.f64(),
  daySeconds: __t.i32(),
  nextEntity: __t.u16(),
  playerListDirty: __t.bool(),
  lastPlayerList: __t.u64(),
  lastAt: __t.timestamp(),
  nextInstance: __t.u32(),
  maxIntervalUs: __t.i64(),
});
export type Clock = __Infer<typeof Clock>;

export const CombatEvent = __t.object("CombatEvent", {
  id: __t.u64(),
  instance: __t.u32(),
  tick: __t.u32(),
  type: __t.u8(),
  entity: __t.u16(),
  other: __t.u16(),
  value: __t.f32(),
  except: __t.u16(),
});
export type CombatEvent = __Infer<typeof CombatEvent>;

export const Config = __t.object("Config", {
  id: __t.u8(),
  owner: __t.identity(),
  serverName: __t.string(),
  motd: __t.string(),
  maxPlayers: __t.i32(),
  allowGuests: __t.bool(),
  issuer: __t.string(),
  audience: __t.string(),
});
export type Config = __Infer<typeof Config>;

export const Corpse = __t.object("Corpse", {
  entityId: __t.u16(),
  instance: __t.u32(),
  x: __t.f32(),
  y: __t.f32(),
  appearance: __t.u8(),
  facing: __t.u8(),
});
export type Corpse = __Infer<typeof Corpse>;

export const Entity = __t.object("Entity", {
  entityId: __t.u16(),
  instance: __t.u32(),
  kind: __t.u8(),
  name: __t.string(),
  appearance: __t.u8(),
  level: __t.u8(),
  armor: __t.array(__t.u16()),
});
export type Entity = __Infer<typeof Entity>;

export const EventActiveQuest = __t.object("EventActiveQuest", {
  quest: __t.u32(),
  progress: __t.array(__t.u32()),
});
export type EventActiveQuest = __Infer<typeof EventActiveQuest>;

export const EventAdminMap = __t.object("EventAdminMap", {
  key: __t.string(),
  name: __t.string(),
});
export type EventAdminMap = __Infer<typeof EventAdminMap>;

export const EventAdminStatus = __t.object("EventAdminStatus", {
  isAdmin: __t.bool(),
  godMode: __t.bool(),
  get maps() {
    return __t.array(EventAdminMap);
  },
});
export type EventAdminStatus = __Infer<typeof EventAdminStatus>;

export const EventCharacterList = __t.object("EventCharacterList", {
  get characters() {
    return __t.array(EventCharacterSummary);
  },
});
export type EventCharacterList = __Infer<typeof EventCharacterList>;

export const EventCharacterResult = __t.object("EventCharacterResult", {
  error: __t.string(),
});
export type EventCharacterResult = __Infer<typeof EventCharacterResult>;

export const EventCharacterSummary = __t.object("EventCharacterSummary", {
  name: __t.string(),
  appearance: __t.u32(),
  lastPlayed: __t.string(),
});
export type EventCharacterSummary = __Infer<typeof EventCharacterSummary>;

export const EventChat = __t.object("EventChat", {
  channel: __t.u32(),
  from: __t.string(),
  text: __t.string(),
});
export type EventChat = __Infer<typeof EventChat>;

export const EventChunkData = __t.object("EventChunkData", {
  epoch: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  indices: __t.array(__t.u32()),
  objects: __t.array(__t.u32()),
});
export type EventChunkData = __Infer<typeof EventChunkData>;

export const EventChunkUnload = __t.object("EventChunkUnload", {
  epoch: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
});
export type EventChunkUnload = __Infer<typeof EventChunkUnload>;

export const EventCombatEvent = __t.object("EventCombatEvent", {
  epoch: __t.u32(),
  type: __t.u32(),
  entity: __t.u32(),
  other: __t.u32(),
  value: __t.f32(),
});
export type EventCombatEvent = __Infer<typeof EventCombatEvent>;

export const EventContentData = __t.object("EventContentData", {
  bundle: __t.byteArray(),
});
export type EventContentData = __Infer<typeof EventContentData>;

export const EventDisconnect = __t.object("EventDisconnect", {
  code: __t.u32(),
  message: __t.string(),
});
export type EventDisconnect = __Infer<typeof EventDisconnect>;

export const EventEntityDespawn = __t.object("EventEntityDespawn", {
  epoch: __t.u32(),
  entityId: __t.u32(),
});
export type EventEntityDespawn = __Infer<typeof EventEntityDespawn>;

export const EventEntityEquipment = __t.object("EventEntityEquipment", {
  epoch: __t.u32(),
  entityId: __t.u32(),
  armor: __t.array(__t.u32()),
});
export type EventEntityEquipment = __Infer<typeof EventEntityEquipment>;

export const EventEntitySpawn = __t.object("EventEntitySpawn", {
  epoch: __t.u32(),
  entityId: __t.u32(),
  kind: __t.u32(),
  name: __t.string(),
  appearance: __t.u32(),
  level: __t.u32(),
  armor: __t.array(__t.u32()),
  x: __t.i32(),
  y: __t.i32(),
  facing: __t.u32(),
  flags: __t.u32(),
});
export type EventEntitySpawn = __Infer<typeof EventEntitySpawn>;

export const EventEntityState = __t.object("EventEntityState", {
  entityId: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  facingFlags: __t.u32(),
  healthPct: __t.u32(),
  stamina: __t.u32(),
  staminaDelay: __t.u32(),
});
export type EventEntityState = __Infer<typeof EventEntityState>;

export const EventFriend = __t.object("EventFriend", {
  name: __t.string(),
  online: __t.bool(),
  zoneName: __t.string(),
  level: __t.u32(),
});
export type EventFriend = __Infer<typeof EventFriend>;

export const EventFriendList = __t.object("EventFriendList", {
  get friends() {
    return __t.array(EventFriend);
  },
});
export type EventFriendList = __Infer<typeof EventFriendList>;

export const EventHarvestState = __t.object("EventHarvestState", {
  epoch: __t.u32(),
  phase: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  durationTicks: __t.u32(),
});
export type EventHarvestState = __Infer<typeof EventHarvestState>;

export const EventIgnoreList = __t.object("EventIgnoreList", {
  names: __t.array(__t.string()),
});
export type EventIgnoreList = __Infer<typeof EventIgnoreList>;

export const EventInventorySync = __t.object("EventInventorySync", {
  get main() {
    return __t.array(EventItemStack);
  },
  get belt() {
    return __t.array(EventItemStack);
  },
  get armor() {
    return __t.array(EventItemStack);
  },
});
export type EventInventorySync = __Infer<typeof EventInventorySync>;

export const EventItemStack = __t.object("EventItemStack", {
  item: __t.u32(),
  count: __t.u32(),
  bound: __t.bool(),
});
export type EventItemStack = __Infer<typeof EventItemStack>;

export const EventLifeState = __t.object("EventLifeState", {
  state: __t.u8(),
  corpseMap: __t.string(),
  corpseX: __t.f32(),
  corpseY: __t.f32(),
});
export type EventLifeState = __Infer<typeof EventLifeState>;

export const EventLootBagDespawn = __t.object("EventLootBagDespawn", {
  epoch: __t.u32(),
  id: __t.u32(),
  reason: __t.u32(),
});
export type EventLootBagDespawn = __Infer<typeof EventLootBagDespawn>;

export const EventLootBagSpawn = __t.object("EventLootBagSpawn", {
  epoch: __t.u32(),
  id: __t.u32(),
  x: __t.f32(),
  y: __t.f32(),
  get contents() {
    return __t.array(EventItemStack);
  },
});
export type EventLootBagSpawn = __Infer<typeof EventLootBagSpawn>;

export const EventMapData = __t.object("EventMapData", {
  epoch: __t.u32(),
  terrain: __t.byteArray(),
});
export type EventMapData = __Infer<typeof EventMapData>;

export const EventNotice = __t.object("EventNotice", {
  kind: __t.u32(),
  text: __t.string(),
});
export type EventNotice = __Infer<typeof EventNotice>;

export const EventNpcDialogue = __t.object("EventNpcDialogue", {
  npc: __t.u32(),
  get options() {
    return __t.array(EventQuestOption);
  },
});
export type EventNpcDialogue = __Infer<typeof EventNpcDialogue>;

export const EventPartyInvite = __t.object("EventPartyInvite", {
  inviter: __t.string(),
  expiresIn: __t.f32(),
});
export type EventPartyInvite = __Infer<typeof EventPartyInvite>;

export const EventPartyMember = __t.object("EventPartyMember", {
  name: __t.string(),
  entityId: __t.u32(),
  appearance: __t.u32(),
  healthPct: __t.u32(),
  zoneName: __t.string(),
  online: __t.bool(),
});
export type EventPartyMember = __Infer<typeof EventPartyMember>;

export const EventPartyPosition = __t.object("EventPartyPosition", {
  name: __t.string(),
  zoneId: __t.u32(),
  instanceId: __t.u32(),
  x: __t.f32(),
  y: __t.f32(),
});
export type EventPartyPosition = __Infer<typeof EventPartyPosition>;

export const EventPartyPositions = __t.object("EventPartyPositions", {
  get members() {
    return __t.array(EventPartyPosition);
  },
});
export type EventPartyPositions = __Infer<typeof EventPartyPositions>;

export const EventPartyState = __t.object("EventPartyState", {
  leader: __t.string(),
  maxSize: __t.u32(),
  get members() {
    return __t.array(EventPartyMember);
  },
});
export type EventPartyState = __Infer<typeof EventPartyState>;

export const EventPlacedEntityState = __t.object("EventPlacedEntityState", {
  epoch: __t.u32(),
  id: __t.string(),
  definition: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  offsetX: __t.i32(),
  offsetY: __t.i32(),
  depleted: __t.bool(),
  removed: __t.bool(),
});
export type EventPlacedEntityState = __Infer<typeof EventPlacedEntityState>;

export const EventPlayerList = __t.object("EventPlayerList", {
  maxPlayers: __t.u32(),
  get entries() {
    return __t.array(EventPlayerListEntry);
  },
});
export type EventPlayerList = __Infer<typeof EventPlayerList>;

export const EventPlayerListEntry = __t.object("EventPlayerListEntry", {
  name: __t.string(),
  zoneName: __t.string(),
  appearance: __t.u32(),
  inMyParty: __t.bool(),
  sameMap: __t.bool(),
});
export type EventPlayerListEntry = __Infer<typeof EventPlayerListEntry>;

export const EventPlayerStats = __t.object("EventPlayerStats", {
  health: __t.u32(),
  maxHealth: __t.u32(),
  level: __t.u32(),
  exp: __t.u32(),
  money: __t.i64(),
  mana: __t.u32(),
  maxMana: __t.u32(),
});
export type EventPlayerStats = __Infer<typeof EventPlayerStats>;

export const EventPong = __t.object("EventPong", {
  token: __t.u32(),
});
export type EventPong = __Infer<typeof EventPong>;

export const EventQuestLog = __t.object("EventQuestLog", {
  get active() {
    return __t.array(EventActiveQuest);
  },
  completed: __t.array(__t.u32()),
});
export type EventQuestLog = __Infer<typeof EventQuestLog>;

export const EventQuestOption = __t.object("EventQuestOption", {
  quest: __t.u32(),
  status: __t.u32(),
});
export type EventQuestOption = __Infer<typeof EventQuestOption>;

export const EventServerHello = __t.object("EventServerHello", {
  serverId: __t.string(),
  serverName: __t.string(),
  maxCharacters: __t.u32(),
});
export type EventServerHello = __Infer<typeof EventServerHello>;

export const EventSnapshot = __t.object("EventSnapshot", {
  epoch: __t.u32(),
  tick: __t.u32(),
  lastProcessedInput: __t.u32(),
  get self() {
    return __t.option(EventEntityState);
  },
  get entities() {
    return __t.array(EventEntityState);
  },
});
export type EventSnapshot = __Infer<typeof EventSnapshot>;

export const EventTalents = __t.object("EventTalents", {
  allocated: __t.array(__t.u32()),
  auras: __t.array(__t.u32()),
});
export type EventTalents = __Infer<typeof EventTalents>;

export const EventTileEntityDespawn = __t.object("EventTileEntityDespawn", {
  epoch: __t.u32(),
  id: __t.u32(),
});
export type EventTileEntityDespawn = __Infer<typeof EventTileEntityDespawn>;

export const EventTileEntitySpawn = __t.object("EventTileEntitySpawn", {
  epoch: __t.u32(),
  id: __t.u32(),
  type: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  data: __t.u32(),
  label: __t.string(),
});
export type EventTileEntitySpawn = __Infer<typeof EventTileEntitySpawn>;

export const EventTileUpdate = __t.object("EventTileUpdate", {
  epoch: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  ground: __t.u32(),
  object: __t.u32(),
});
export type EventTileUpdate = __Infer<typeof EventTileUpdate>;

export const EventTimeOfDay = __t.object("EventTimeOfDay", {
  time: __t.f32(),
  daySeconds: __t.u32(),
});
export type EventTimeOfDay = __Infer<typeof EventTimeOfDay>;

export const EventTradeInvite = __t.object("EventTradeInvite", {
  from: __t.string(),
  expiresIn: __t.f32(),
});
export type EventTradeInvite = __Infer<typeof EventTradeInvite>;

export const EventTradeOffer = __t.object("EventTradeOffer", {
  get slots() {
    return __t.array(EventTradeSlot);
  },
  copper: __t.i64(),
});
export type EventTradeOffer = __Infer<typeof EventTradeOffer>;

export const EventTradeSlot = __t.object("EventTradeSlot", {
  slot: __t.u32(),
  item: __t.u32(),
  count: __t.u32(),
});
export type EventTradeSlot = __Infer<typeof EventTradeSlot>;

export const EventTradeState = __t.object("EventTradeState", {
  get view() {
    return __t.option(EventTradeView);
  },
});
export type EventTradeState = __Infer<typeof EventTradeState>;

export const EventTradeView = __t.object("EventTradeView", {
  partner: __t.string(),
  revision: __t.u32(),
  get mine() {
    return __t.option(EventTradeOffer);
  },
  mineAccepted: __t.bool(),
  get theirs() {
    return __t.array(EventItemStack);
  },
  theirCopper: __t.i64(),
  theirsAccepted: __t.bool(),
});
export type EventTradeView = __Infer<typeof EventTradeView>;

export const EventWelcome = __t.object("EventWelcome", {
  entityId: __t.u32(),
  tickRate: __t.u32(),
  serverTick: __t.u32(),
  serverName: __t.string(),
  motd: __t.string(),
  maxPlayers: __t.u32(),
  characterName: __t.string(),
  appearance: __t.u32(),
});
export type EventWelcome = __Infer<typeof EventWelcome>;

export const EventZoneChange = __t.object("EventZoneChange", {
  epoch: __t.u32(),
  zoneId: __t.u32(),
  instanceId: __t.u32(),
  zoneName: __t.string(),
  widthTiles: __t.u32(),
  heightTiles: __t.u32(),
  flags: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  facing: __t.u32(),
  serverTick: __t.u32(),
  terrainHash: __t.u64(),
  get time() {
    return __t.option(EventTimeOfDay);
  },
  get lights() {
    return __t.array(ZoneLight);
  },
});
export type EventZoneChange = __Infer<typeof EventZoneChange>;

export const FriendRow = __t.object("FriendRow", {
  character: __t.u64(),
  name: __t.string(),
});
export type FriendRow = __Infer<typeof FriendRow>;

export const HealZone = __t.object("HealZone", {
  id: __t.u64(),
  instance: __t.u32(),
  x: __t.f32(),
  y: __t.f32(),
  item: __t.u16(),
  caster: __t.u16(),
  startTick: __t.u32(),
  endTick: __t.u32(),
});
export type HealZone = __Infer<typeof HealZone>;

export const IgnoreRow = __t.object("IgnoreRow", {
  account: __t.identity(),
  name: __t.string(),
});
export type IgnoreRow = __Infer<typeof IgnoreRow>;

export const Instance = __t.object("Instance", {
  id: __t.u32(),
  zone: __t.u16(),
  dungeon: __t.bool(),
  mapKey: __t.string(),
  name: __t.string(),
  flags: __t.u8(),
  width: __t.i32(),
  height: __t.i32(),
  seed: __t.u32(),
  owner: __t.string(),
  returnInstance: __t.u32(),
  returnX: __t.f32(),
  returnY: __t.f32(),
  emptySince: __t.option(__t.u64()),
});
export type Instance = __Infer<typeof Instance>;

export const InstanceSeed = __t.object("InstanceSeed", {
  instance: __t.u32(),
  placementHash: __t.u64(),
  terrainHash: __t.u64(),
  spawnerHash: __t.u64(),
});
export type InstanceSeed = __Infer<typeof InstanceSeed>;

export const Mob = __t.object("Mob", {
  entityId: __t.u16(),
  instance: __t.u32(),
  type: __t.u8(),
  level: __t.i32(),
  x: __t.f32(),
  y: __t.f32(),
  facing: __t.u8(),
  moving: __t.bool(),
  health: __t.f32(),
  maxHealth: __t.i32(),
  contactDamage: __t.i32(),
  target: __t.u16(),
  hopTimer: __t.f32(),
  hopRemaining: __t.f32(),
  hopX: __t.f32(),
  hopY: __t.f32(),
  knockX: __t.f32(),
  knockY: __t.f32(),
  nextContact: __t.u32(),
  lastDamaged: __t.u32(),
  taggers: __t.array(__t.u64()),
  spawner: __t.i32(),
});
export type Mob = __Infer<typeof Mob>;

export const MyOutbox = __t.object("MyOutbox", {});
export type MyOutbox = __Infer<typeof MyOutbox>;

export const Outbox = __t.object("Outbox", {
  id: __t.u64(),
  recipient: __t.identity(),
  connection: __t.connectionId(),
  tick: __t.u32(),
  get notification() {
    return WorldNotification;
  },
});
export type Outbox = __Infer<typeof Outbox>;

export const Party = __t.object("Party", {
  id: __t.u64(),
  leader: __t.u64(),
});
export type Party = __Infer<typeof Party>;

export const PartyInvite = __t.object("PartyInvite", {
  target: __t.u64(),
  inviter: __t.u64(),
  party: __t.u64(),
  expires: __t.u32(),
});
export type PartyInvite = __Infer<typeof PartyInvite>;

export const PartyMember = __t.object("PartyMember", {
  character: __t.u64(),
  party: __t.u64(),
  name: __t.string(),
  appearance: __t.u8(),
  order: __t.u64(),
});
export type PartyMember = __Infer<typeof PartyMember>;

export const PlacedEntity = __t.object("PlacedEntity", {
  key: __t.string(),
  instance: __t.u32(),
  placementId: __t.string(),
  definition: __t.u16(),
  revision: __t.u32(),
  x: __t.i32(),
  y: __t.i32(),
  offsetX: __t.i32(),
  offsetY: __t.i32(),
  depleted: __t.bool(),
  regrowTick: __t.u32(),
});
export type PlacedEntity = __Infer<typeof PlacedEntity>;

export const Player = __t.object("Player", {
  characterId: __t.u64(),
  identity: __t.identity(),
  connection: __t.connectionId(),
  entityId: __t.u16(),
  instance: __t.u32(),
  name: __t.string(),
  appearance: __t.u8(),
  epoch: __t.u8(),
  x: __t.i32(),
  y: __t.i32(),
  facing: __t.u8(),
  moving: __t.bool(),
  running: __t.bool(),
  exhausted: __t.bool(),
  stamina: __t.i32(),
  staminaDelay: __t.u8(),
  inputs: __t.array(__t.u64()),
  lastReceived: __t.u32(),
  lastProcessed: __t.u32(),
  inputTokens: __t.f32(),
  starved: __t.i32(),
  lastInputAt: __t.timestamp(),
  health: __t.f32(),
  mana: __t.f32(),
  maxHealth: __t.i32(),
  maxMana: __t.i32(),
  level: __t.i32(),
  syncedHealth: __t.i32(),
  syncedMana: __t.i32(),
  statsDirty: __t.bool(),
  nextAttack: __t.u32(),
  nextConsumable: __t.u32(),
  portalCooldownUntil: __t.u32(),
  feetX: __t.i32(),
  feetY: __t.i32(),
  harvesting: __t.bool(),
  harvestX: __t.i32(),
  harvestY: __t.i32(),
  harvestTarget: __t.u8(),
  harvestWater: __t.bool(),
  harvestEnd: __t.u32(),
  admin: __t.bool(),
  godMode: __t.bool(),
  dead: __t.bool(),
  chatTokens: __t.f32(),
  lastWhisperFrom: __t.string(),
  party: __t.u64(),
  sentPartyState: __t.string(),
  sentFriends: __t.string(),
  terrainSent: __t.bool(),
  violations: __t.i32(),
  enteredAt: __t.timestamp(),
  harvestTile: __t.u16(),
  gatherEntityId: __t.string(),
  stun: __t.u8(),
  blocking: __t.bool(),
  healthRegen: __t.f32(),
  manaRegen: __t.f32(),
  auras: __t.array(__t.u16()),
});
export type Player = __Infer<typeof Player>;

export const Projectile = __t.object("Projectile", {
  id: __t.u64(),
  instance: __t.u32(),
  owner: __t.u64(),
  weapon: __t.u16(),
  x: __t.f32(),
  y: __t.f32(),
  dX: __t.f32(),
  dY: __t.f32(),
  travelled: __t.f32(),
  startTick: __t.u32(),
  viewTick: __t.u32(),
});
export type Projectile = __Infer<typeof Projectile>;

export const QuestRow = __t.object("QuestRow", {
  quest: __t.u16(),
  completed: __t.bool(),
  counts: __t.array(__t.i32()),
});
export type QuestRow = __Infer<typeof QuestRow>;

export const RequestBudget = __t.object("RequestBudget", {
  identity: __t.identity(),
  requestTokens: __t.f32(),
  helloTokens: __t.f32(),
  inviteTokens: __t.f32(),
  requestAt: __t.timestamp(),
  helloAt: __t.timestamp(),
  inviteAt: __t.timestamp(),
});
export type RequestBudget = __Infer<typeof RequestBudget>;

export const SpawnerState = __t.object("SpawnerState", {
  key: __t.u64(),
  readyAt: __t.u32(),
});
export type SpawnerState = __Infer<typeof SpawnerState>;

export const Stack = __t.object("Stack", {
  item: __t.u16(),
  count: __t.i32(),
  bound: __t.bool(),
});
export type Stack = __Infer<typeof Stack>;

export const TickSchedule = __t.object("TickSchedule", {
  id: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type TickSchedule = __Infer<typeof TickSchedule>;

export const TileEntity = __t.object("TileEntity", {
  id: __t.u32(),
  instance: __t.u32(),
  type: __t.u8(),
  x: __t.i32(),
  y: __t.i32(),
  data: __t.u32(),
  label: __t.string(),
});
export type TileEntity = __Infer<typeof TileEntity>;

export const Trade = __t.object("Trade", {
  id: __t.u64(),
  a: __t.u64(),
  b: __t.u64(),
  get slotsA() {
    return __t.array(TradeSlotRow);
  },
  get slotsB() {
    return __t.array(TradeSlotRow);
  },
  copperA: __t.i64(),
  copperB: __t.i64(),
  acceptedA: __t.bool(),
  acceptedB: __t.bool(),
  revision: __t.u32(),
  revisionA: __t.u64(),
  revisionB: __t.u64(),
});
export type Trade = __Infer<typeof Trade>;

export const TradeRequest = __t.object("TradeRequest", {
  target: __t.u64(),
  from: __t.u64(),
  expires: __t.u32(),
});
export type TradeRequest = __Infer<typeof TradeRequest>;

export const TradeSlotRow = __t.object("TradeSlotRow", {
  slot: __t.i32(),
  item: __t.u16(),
  count: __t.i32(),
});
export type TradeSlotRow = __Infer<typeof TradeSlotRow>;

export const VisibleBag = __t.object("VisibleBag", {});
export type VisibleBag = __Infer<typeof VisibleBag>;

// The tagged union or sum type for the algebraic type `WorldNotification`.
export const WorldNotification = __t.enum("WorldNotification", {
  get Disconnect() {
    return EventDisconnect;
  },
  get Pong() {
    return EventPong;
  },
  get ServerHello() {
    return EventServerHello;
  },
  get ContentData() {
    return EventContentData;
  },
  get CharacterList() {
    return EventCharacterList;
  },
  get CharacterResult() {
    return EventCharacterResult;
  },
  get Welcome() {
    return EventWelcome;
  },
  get ZoneChange() {
    return EventZoneChange;
  },
  get MapData() {
    return EventMapData;
  },
  get ChunkData() {
    return EventChunkData;
  },
  get ChunkUnload() {
    return EventChunkUnload;
  },
  get TileUpdate() {
    return EventTileUpdate;
  },
  get EntitySpawn() {
    return EventEntitySpawn;
  },
  get EntityDespawn() {
    return EventEntityDespawn;
  },
  get EntityEquipment() {
    return EventEntityEquipment;
  },
  get Snapshot() {
    return EventSnapshot;
  },
  get CombatEvent() {
    return EventCombatEvent;
  },
  get PlayerStats() {
    return EventPlayerStats;
  },
  get InventorySync() {
    return EventInventorySync;
  },
  get HarvestState() {
    return EventHarvestState;
  },
  get TileEntitySpawn() {
    return EventTileEntitySpawn;
  },
  get TileEntityDespawn() {
    return EventTileEntityDespawn;
  },
  get LootBagSpawn() {
    return EventLootBagSpawn;
  },
  get LootBagDespawn() {
    return EventLootBagDespawn;
  },
  get Notice() {
    return EventNotice;
  },
  get Chat() {
    return EventChat;
  },
  get PlayerList() {
    return EventPlayerList;
  },
  get AdminStatus() {
    return EventAdminStatus;
  },
  get PartyState() {
    return EventPartyState;
  },
  get PartyInvite() {
    return EventPartyInvite;
  },
  get PartyPositions() {
    return EventPartyPositions;
  },
  get IgnoreList() {
    return EventIgnoreList;
  },
  get NpcDialogue() {
    return EventNpcDialogue;
  },
  get QuestLog() {
    return EventQuestLog;
  },
  get TradeInvite() {
    return EventTradeInvite;
  },
  get TradeState() {
    return EventTradeState;
  },
  get FriendList() {
    return EventFriendList;
  },
  get TimeOfDay() {
    return EventTimeOfDay;
  },
  get PlacedEntityState() {
    return EventPlacedEntityState;
  },
  get Talents() {
    return EventTalents;
  },
  get LifeState() {
    return EventLifeState;
  },
});
export type WorldNotification = __Infer<typeof WorldNotification>;

export const ZoneLight = __t.object("ZoneLight", {
  x: __t.i32(),
  y: __t.i32(),
  radius: __t.u32(),
  color: __t.u32(),
  flicker: __t.bool(),
});
export type ZoneLight = __Infer<typeof ZoneLight>;

